import type { ChartPanel } from 'features/charts-v2/types/filter-hash/v2'
import type { ChartRequest } from 'features/charts-v2/types/yogiql'

/** The panel fields a stored YogiQL request stands in for. Everything else on
 *  the panel (identity, presetId, every display key, sortDirection) is stored
 *  as it is. */
export const YOGIQL_QUERY_FIELDS = [
  'chartType',
  'metrics',
  'breakdowns',
  'filters',
  'dateRange',
  'timeBucket',
  'searchTerms',
  'searchCriteria',
  'smartSearchEnabled',
] as const satisfies readonly (keyof ChartPanel)[]

export type PanelQueryFields = Pick<
  ChartPanel,
  (typeof YOGIQL_QUERY_FIELDS)[number]
>

/** A panel saved in YogiQL form: the query fields replaced by the
 *  request. Written behind `enhanced_dialect`; read on every hub. */
export type YogiQLStoredPanel = Omit<
  ChartPanel,
  (typeof YOGIQL_QUERY_FIELDS)[number]
> & { request: ChartRequest }

/** What a store holds per panel: today's panel, or the YogiQL form. */
export type StoredPanel = ChartPanel | YogiQLStoredPanel

/** Readers dispatch per panel on `request`; a legacy panel never has one. */
export const isYogiQLStoredPanel = (
  panel: unknown,
): panel is YogiQLStoredPanel =>
  typeof panel === 'object' && panel !== null && 'request' in panel
